/*eslint-disable*/
import { useRef, useState } from 'react';
import {
  Box,
  FormControlLabel,
  Grid,
  Paper,
  Radio,
  RadioGroup,
  Typography,
} from '@mui/material';
import { config } from '../../appConfig'
import CustomSwitches from '../components/CustomSwitches';
import DataCard, { DataCardProps } from '../components/DataCard';
import GradesDemLineChart from '../components/GradesDemLineChart';
import GradesDemChainage from '../components/GradesDemChainage';
import HorizontalColorRamp from '../components/ColorRamp';
import MapComponent from '../components/Map'

export default function GradesDemPage() {
  const mapDOMId = 'grades-dem-map'
  const [selectedDirection, setSelectedDirection] = useState<'forward' | 'reverse'>('forward');
  const [distances, setDistances] = useState<number[]>([]);
  const [grades, setGrades] = useState<number[]>([]);
  const [maxUphillGrade, setMaxUphillGrade] = useState<number>(0);
  const [maxDownhillGrade, setMaxDownhillGrade] = useState<number>(0);
  const cards: DataCardProps[] = [
    {
      title: 'Linked Review Zone (Road Link Plan)',
      value: 'Ch 0.00-65.677',
      description: 'Context: limited overtaking opportunities noted in report',
      borderColor: 'rgb(0, 119, 255)',
      // faq: 'Context: limited overtaking opportunities noted in report Context: limited overtaking opportunities noted in report Context: limited overtaking opportunities noted in report'
    },
    {
      title: 'Max Uphill Grade',
      value: maxUphillGrade?.toString(),
      description: 'Positive grades along calibrated chainage',
      borderColor: 'rgb(13, 197, 13)',
    },
    {
      title: 'Max Downhill Grade',
      value: maxDownhillGrade?.toString(),
      description: 'Negative grades along calibrated chainage',
      borderColor: 'rgb(128, 128, 0)',
    },
    // {
    //   title: 'Selected link length',
    //   value: '65.71 km',
    //   description: 'From sections / capacity extents',
    //   borderColor: 'rgb(138, 43, 226)',
    // },
    // {
    //   title: 'Direction Spreadsheet\nLinked Review Zone (Road Link Plan)',
    //   value: 'Ch 10.74-20.93',
    //   description: 'Context: limited overtaking opportunities noted in report',
    //   borderColor: 'rgb(255, 165, 0)',
    // },
  ];

  // Ref for the legend web component
  const legendRef = useRef<any>(null);
  const TARGET_LAYER_ID = "19eb54eb147-layer-62" // GRADES
  // const TARGET_LAYER_TITLE = "Grades (Emerald to Springsure)"

  // Handler to be passed to MapComponent
  const handleViewReady = (
    event: Event,
  ) => {
    const view = ((event as any).target.view);
    const map = ((event as any).target.map);

    if (!map || !view) return;

    // Set only the target layer in the legend when view/map change
    // Find the layer by id
    const targetLayer = map.layers.find((l: any) => l.id === TARGET_LAYER_ID);
    // console.log('targetLayer', targetLayer)
    if (legendRef.current) {
      legendRef.current.view = view;
      
      if (targetLayer) {
        legendRef.current.layerInfos = [];
        legendRef.current.layerInfos = [
          {
            layer: targetLayer,
            title: targetLayer.title
          }
        ];
      } else {
        // If not found, clear the legend or keep empty
        legendRef.current.layerInfos = [];
        console.warn("Layer with id " + TARGET_LAYER_ID + " not found on the map.");
      }
    };

    
    
  };

  const handleViewChange = (
    event: Event,
  ) => {
    const view = ((event as any).target.view);
    const map = ((event as any).target.map);

    if (!map || !view) return;

    async function fetchUpdate() {
      const grades = map?.layers?.items?.find((l: any) => l?.title === "Grades (Emerald to Springsure)");
      const gradesFeatureSet = await grades?.queryFeatures({
        geometry: view.extent,
        outFields: ['*']
      });
      
      if (!isNaN(gradesFeatureSet?.features?.length)) {
        const gradeValues:number[] = []
        const distanceValues:number[] = []
        const features = [...gradesFeatureSet?.features.sort((a: any, b:any) => parseFloat(a.attributes.from_ch_km) - parseFloat(b.attributes.from_ch_km))]
        const maxUphillGrade:number = features?.length ? features?.reduce((max, item) => item.attributes.grade_pct > max.attributes.grade_pct ? item : max).attributes.grade_pct : 0
        const maxDownhillGrade: number = features?.length ? features?.reduce((min, item) => item.attributes.grade_pct > min.attributes.grade_pct ? min : item).attributes.grade_pct : 0
        features?.map((item: any)=>{
          gradeValues.push(parseFloat(item.attributes.grade_pct))
          distanceValues.push(parseFloat(item.attributes.from_ch_km))
        })
        setMaxUphillGrade(maxUphillGrade)
        setMaxDownhillGrade(maxDownhillGrade)
        setGrades(gradeValues)
        setDistances(distanceValues)
      }
    }
    fetchUpdate()
  }

  return (
    <Box>
      {/* MAIN CONTENT */}
      <Grid container>
        {/* SIDEBAR */}
        <Grid
          size={{ xs: 6, md: 2.5 }}
          sx={{
            overflowY: 'auto',
            height: 'calc(100vh - 64px - 24px - 24px - 24.33px)' // screenHeight - navBarHeight - paddingTop - paddingBottom
          }}
        >
          <Paper elevation={0} sx={{ p: 2, pb: 0 }}>
            <Typography variant='body1' sx={{ p: 2, pt: 0, fontWeight: 'bold' }}>GRADE SCREENING KPIS</Typography>
            {cards.map((card) => (
              <DataCard
                key={card.title}
                title={card.title.toUpperCase()}
                value={card.value}
                description={card.description}
                borderColor={card.borderColor}
                faq={card.faq}
                sx={{
                  borderLeft: `3px solid ${card.borderColor}`,
                }}
              />
            ))}
          </Paper>
          {/* <Paper elevation={2} sx={{ m: 2 }}>
            <Typography variant='body1' sx={{ p: 2, fontWeight: 'bold' }}>DISPLAY OPTIONS</Typography>
            <CustomSwitches />
          </Paper> */}
        </Grid>
        {/* MAIN AREA */}
        <Grid
          size={{ xs: 12, md: 9.5 }}
          sx={{
            overflowY: 'auto',
            height: 'calc(100vh - 64px - 24px - 24px - 24.33px)' // screenHeight - navBarHeight - paddingTop - paddingBottom
          }}
        >
          <Paper
            elevation={0}
            sx={{
              height: '100%'
            }}
          >
            <MapComponent referenceId={mapDOMId} mapItem={config.mapItemId} directionFilter={selectedDirection} onViewReady={handleViewReady} onViewChange={handleViewChange}>
              <arcgis-expand id="map-filter-expand" slot="bottom-right" expand-icon="chart-gear" expand-tooltip="Direction Filter">
                <div style={{ width: '40vw', height: '40vh', resize: 'both' }}>
                  <GradesDemChainage 
                    width={1000} 
                    height={500}
                    distances={distances}
                    grades={grades}
                  />
                </div>
              </arcgis-expand>
              <arcgis-expand id="map-widget-firstposition" expanded slot="bottom-left" expandTooltip="Legend">
                <arcgis-legend ref={legendRef} />
              </arcgis-expand>
              {/* <arcgis-expand id="map-filter-expand" slot="top-left" expand-icon="arrow-right-left" expand-tooltip="Direction Filter">
                <div style={{ width: '10vw', padding: '1em' }}>
                  <Typography variant="caption" sx={{ fontWeight: 'bold' }}>Direction</Typography>
                  <RadioGroup
                    row
                    value={selectedDirection}
                    onChange={(e, value) => setSelectedDirection(value as 'forward' | 'reverse')}
                  >
                    <FormControlLabel value="forward" control={<Radio />} label="Forward" slotProps={{ typography: { variant: 'caption' } }} />
                    <FormControlLabel value="reverse" control={<Radio />} label="Reverse" slotProps={{ typography: { variant: 'caption' } }} />
                  </RadioGroup>
                </div>
              </arcgis-expand>
              <arcgis-expand id="map-filter-expand" slot="top-left" expand-icon="configure" expand-tooltip="Display Options">
                <div style={{ width: '10vw', padding: '1em' }}>
                  <Typography variant='caption' sx={{ fontWeight: 'bold' }}>Display Options</Typography>
                  <CustomSwitches />
                </div>
              </arcgis-expand> */}
            </MapComponent>
            {/* <Grid container sx={{ height: '100%' }}>
              <Grid size={{ xs: 6, md: 7 }}>
                <MapComponent referenceId={mapDOMId} mapItem={config.mapItemId} directionFilter={selectedDirection} onViewReady={handleViewReady}>
                  <arcgis-expand id="map-filter-expand" slot="top-left" expand-icon="arrow-right-left" expand-tooltip="Direction Filter">
                    <div style={{ width: '10vw', padding: '1em' }}>
                      <Typography variant="caption" sx={{ fontWeight: 'bold' }}>Direction</Typography>
                      <RadioGroup
                        row
                        value={selectedDirection}
                        onChange={(e, value) => setSelectedDirection(value as 'forward' | 'reverse')}
                      >
                        <FormControlLabel value="forward" control={<Radio />} label="Forward" slotProps={{ typography: { variant: 'caption' } }} />
                        <FormControlLabel value="reverse" control={<Radio />} label="Reverse" slotProps={{ typography: { variant: 'caption' } }} />
                      </RadioGroup>
                    </div>
                  </arcgis-expand>
                  <arcgis-expand id="map-filter-expand" slot="top-left" expand-icon="configure" expand-tooltip="Display Options">
                    <div style={{ width: '10vw', padding: '1em' }}>
                      <Typography variant='caption' sx={{ fontWeight: 'bold' }}>Display Options</Typography>
                      <CustomSwitches />
                    </div>
                  </arcgis-expand>
                  <arcgis-expand expanded={false} slot="top-right" expandTooltip="Legend">
                    <arcgis-legend ref={legendRef} />
                  </arcgis-expand>
                </MapComponent>
              </Grid>
              <Grid
                size={{ xs: 6, md: 5 }}
              >
                <Paper sx={{ height: '100%', width: '100%', paddingInline: 2 }}>
                  <GradesDemLineChart width={500} height={180} />
                  <br />
                  <GradesDemChainage width={500} height={180} />
                  <br />
                  <Typography style={{ fontWeight: 600 }}>Grade (%)</Typography>
                  <HorizontalColorRamp
                    width="100%"
                    height={20}
                    colors={['#4CFF4C', '#ffeb3b', '#d32f2f']}
                    showLabels
                    labels={['0%', '1.5%', '2.5%', '3.75%', '5%']}
                    sx={{ borderRadius: 2, p: 2, }}
                  />
                </Paper>
              </Grid>
            </Grid> */}
          </Paper>
          {/* <Paper
            elevation={0}
            sx={{
              p: 2,
              height: '30%',
              border: '1px solid #ccc',
              width: '100%'
            }}
          >
            <GradesDemChainage width={1200} height={220} />
          </Paper> */}
        </Grid >
      </Grid >
    </Box >
  )
}